import { render, staticRenderFns } from "./ImageDisplay.vue?vue&type=template&id=6b7517d5&scoped=true&lang=html&"
import script from "./ImageDisplay.vue?vue&type=script&lang=js&"
export * from "./ImageDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ImageDisplay.vue?vue&type=style&index=0&id=6b7517d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7517d5",
  null
  
)

export default component.exports